import { Link } from "~/components/Link";
import { PlanTypes, User } from "~/modules/user/store/types";
import { Routes } from "~/routes";

// // // //

// function UpgradeToPro() {
//     return (
//         <Link href={Routes.pricing} analyticsLabel="Plan Badge - Upgrade">
//             <div className="hidden md:flex items-center gap-1.5 rounded-full bg-linear-to-r from-blue-400 to-blue-500 px-3 py-1 select-none whitespace-nowrap hover:from-blue-500 hover:to-blue-600 transition-all shadow-sm hover:shadow-md">
//                 <FontAwesomeIcon
//                     icon={faBolt}
//                     className="h-3.5 w-3.5 text-white"
//                 />
//                 <span className="text-sm font-semibold text-white">
//                     Upgrade to Pro
//                 </span>
//             </div>
//         </Link>
//     );
// }

export function PlanBadge(props: { user: User }) {
    const { user } = props;

    if (!user) {
        // return <UpgradeToPro />;
        return null;
    }

    const plan = user?.organization?.plan ?? null;

    if (!plan) {
        return null;
    }

    if (!user.email) {
        // return <UpgradeToPro />;
        return null;
    }

    if (plan.type === PlanTypes.FREE) {
        // return <UpgradeToPro />;
        return null;
    }

    const isTrialPlan =
        plan.type === PlanTypes.TRIAL_STARTER ||
        plan.type === PlanTypes.TRIAL_ALL_ACCESS ||
        plan.type === PlanTypes.TRIAL_DATA_DOWNLOADS;

    if (!isTrialPlan) {
        return null;
    }

    return (
        <Link href={Routes.settingsPlan} analyticsLabel="Plan Badge - Trial">
            <div className="hidden md:flex items-center gap-1.5 rounded-sm border border-yellow-600/20 bg-yellow-50 px-3 py-1 select-none whitespace-nowrap hover:bg-yellow-100 transition-colors">
                <span className="text-sm font-medium text-yellow-700">
                    Trial
                </span>
            </div>
        </Link>
    );
}
